export default {
    title: 'Bilete online Delfinariu Constanta',
    search: 'Cauta',
    all_states: 'Toate judetele',
    all_museums: 'Muzee disponibile',
    homepage_title: 'Delfinariu Constanta',
    homepage_desc: 'Bine ai venit! Aceasta este pagina oficiala de vanzare a biletelor online pentru vizitarea Delfinariu Constanta.',
    cart: 'Cos de cumparaturi',
    no_tickets: 'Niciun bilet',
    checkout: 'Finalizeaza comanda',
    ticket: 'bilet',
    next_step: 'Pasul urmator',
    select_tickets: 'Selecteaza bilete',
    read_more: 'Citeste mai mult',
    read_less: 'Citeste mai putin',
    museums: 'Muzee',
    login: 'Autentificare',
    my_account: 'Contul meu',
    register: 'Cont nou',
    create_account: 'Creează cont',
    create_account_desc:'pentru acces facil la istoricul comenzilor tale',
    continue_as_guest: 'Continua fara cont',
    email: 'Adresa de email',
    phone: 'Telefon',
    firstName: 'Prenume',
    lastName: 'Nume',
    password: 'Parola',
    confirm_password: 'Confirma parola',
    accept_newsletter: 'Doresc sa ma abonez la newsletter',
    send_sms: 'Doresc sa primesc biletele si prin sms',
    terms_conditions: 'termenele si conditiile',
    authentication: 'Autentificare',
    use_form_below: 'Foloseste formularul de mai jos pentru a te autentifica si a avea acces la biletele tale',
    forgot_password: 'Am uitat parola',
    new_account: 'Cont Nou',
    new_user: 'Client nou',
    reset_password: 'Resetati parola',
    enter_email_to_reset_password: 'Introduceti adresa de email a contului pentru a reseta parola',
    reset_password_button: 'Reseteaza parola',
    follow_email_instructions: 'Urmareste instructiunile trimise pe email pentru a-ti reseta parola.',
    terms_and_conditions: 'Termeni si conditii',
    terms_intro: 'Prin achiziționarea unui bilet prin delfinariu.bilet.ro sunteți de acord cu termenii și condițiile următoare, pe care vă obligați să le respectați:',
    terms_detail_1: 'Biletul nu poate fi schimbat sau returnat indiferent de motivul invocat.',
    terms_detail_2: 'In cazul in care exista suspiciuni de folosire de catre dumneavoastra a site-ului delfinariu.bilet.ro in scopuri rau intentionate si/sau abuzive cum ar fi dar nelimitandu-se la blocarea locurilor in mod repetat fara finalizarea comenzii, crearea unor conturi multiple si folosirea lor in alt scop decat acela de achizitionare bilete, realizarea unor actiuni ce pot duce la incarcarea in mod excesiv si stresarea site-ului delfinariu.bilet.ro, in aceste cazuri delfinariu.bilet.ro poate sa va suspende temporar contul mergand pana la inchiderea lui in cazuri exceptionale. delfinariu.bilet.ro nu va fi nevoita sa va anunte pentru deciziile luate si nici sa dea explicatii, acestea putand fi permanente. De asemenea delfinariu.bilet.ro isi rezerva dreptul de a instiinta organele abilitate in legatura cu actiunile intreprinse de catre dumneavoastra.',
    terms_detail_3: 'Achiziționarea biletului presupune ca sunteți de acord cu termenii și condițiile impuse de Delfinariu Constanta indiferent de modalitatea în care sunt afișate sau transmise și pe care va obligați sa le respectati. Totodata este obligația dumneavoastră sa va interesați de ele și sa adresați întrebări direct Delfinariu Constanta în caz de nelămuriri.',
    terms_detail_4: 'delfinariu.bilet.ro solicita o taxa de procesare cat si una de transmitere a biletelor prin SMS pe care sunteti de acord sa le platiti; acestea reprezinta costurile necesare pentru procesarea comenzii dumneavoastra in conditii optime cat si costul trimiterii SMS-ului pentru biletele achizitionate.',
    terms_detail_5: 'delfinariu.bilet.ro nu este responsabilă pentru acțiunile ce nu au legătură cu procedura de vânzare bilete.',
    terms_detail_6: 'Daca biletele cumparate de la delfinariu.bilet.ro vor fi revândute sau transferate în scopul obținerii de avantaje materiale de către o terță parte neautorizată de delfinariu.bilet.ro, Delfinariu Constanta, agenții răspunzători cu supravegherea locației, cât și reprezentanții delfinariu.bilet.ro pot refuza intrarea deținătorilor biletelor in incinta Delfinariu Constanta, inclusiv evacuarea lor din locație.',
    terms_detail_7: 'Daca nu este altfel specificat, biletul este valabil pentru accesul unei singure persoane la data si intervalul orar menționate pe bilet.',
    terms_detail_8: 'Delfinariu Constanta are dreptul să modifice data si intervalul orar, noile informații fiind anunțate prin mijloace de comunicare specifice.',
    terms_detail_9: 'Asigurați-vă că ajungeți în timp util astfel încât să intrați în locație în intervalul orar înscris pe bilet. Delfinariu Constanta își rezervă dreptul de a interzice accesul daca ajungeti inainte sau dupa data si intervalul orar inscriptionat pe bilet.',
    terms_detail_10: 'Acest bilet nu poate fi dat ca premiu în cadrul niciunui concurs fără acordul prealabil al Delfinariu Constanta.',
    terms_detail_11: 'delfinariu.bilet.ro nu este responsabilă pentru prejudiciile aduse de către terți oricărui deținător de bilet achiziționat prin delfinariu.bilet.ro.',
    terms_detail_12: 'Este interzis accesul in Delfinariu Constanta cu băuturi alcoolice, droguri, substanțe periculoase, obiecte contondente și arme de orice natură; deținătorii de bilete pot fi controlați la intrarea în locație pentru a se asigura respectarea regulilor anunțate.',
    terms_detail_13: 'Consumul de droguri sau de alte substante ilegale in Delfinariu Constanta constituie infractiune si va fi pedepsita conform prevederilor legale în vigoare.',
    terms_detail_14: 'Achiziționarea biletului presupune că sunteți de acord cu termenii și condițiile afișate pe site-ul delfinariu.bilet.ro cât și cu <a href="https://www.delfinariu.ro/regulament-de-vizitare/" target="_blank"><b>Regulamentul de vizitare</b></a> afisat pe delfinariu.ro, termeni, condiții și regulament pe care vă obligați să le respectați.',
    response_payment: 'Raspuns plata',
    payment_confirmed_congratulations: 'Plata a fost confirmata. Felicitari!',
    open_e_ticket: 'Deschide E-BILET',
    order_not_confirmed_error_message: 'Comanda nu a putut fi confirmata. Mesaj de eroare:',
    please_try_again_to_purchase_tickets: 'Te rugam sa incerci din nou achizitionarea de bilete.',
    please_pay_again_tickets: 'Te rugam sa incerci din nou plata biletelor. Locurile sunt blocate pentru tine pana la',
    museum_list: 'Lista muzee',
    back: 'Inapoi',
    orders: 'Comenzi',
    personal_info: 'Date personale',
    change_password: 'Schimba parola',
    exit: 'Iesire',
    no_orders: 'Nu ai nici o comanda',
    save: 'Salveaza',
    current_password: 'Parola curenta',
    new_password: 'Parola noua',
    delete: 'Șterge',
    tickets_total: 'Total bilete',
    tax: 'Taxe procesare comanda',
    total_payment: 'Total de plata',
    pay: 'Plateste',
    pay_again: 'Plateste din nou',
    continue_shopping: 'Cumpara si alte bilete',
    cookie_message: 'Folosim cookie-uri pentru a îmbunătăți experiența ta pe site. Prin continuarea navigării ești de acord cu politica noastră de confidențialitate.',
    cookie_accept: 'Accept',
    cookie_learn_more: 'Politica GDPR',
    tickets_email: 'Aici vei primi biletele',
    modify: 'Modifica',
    my_cart: 'Cosul meu',
    user_details: 'Detalii utilizaor',
    payment: 'Plata',
    terms: 'Termeni si conditii',
    gdpr: 'Termeni GDPR',
    last_tickets: 'Ultimele bilete',
    sold_out: 'Epuizat',
    pick_tickets: 'Alege bilete',
    not_found_order: 'Comanda inexistenta',
    expiration_date: 'Data expirare',
    open_eticket: 'Deschide E-BILET',
    payment_method: 'Metoda de plata',
    delivery_method: 'Metoda de livrare',
    show_details: 'vezi detalii',
    hide_details: 'ascunde detalii',
    Confirmat: 'Confirmat',
    Neconfirmat: 'Neconfirmat',
    Anulat: 'Anulat',
    tickets: 'Bilete',
    my_order: 'Comanda mea',
    what_to_visit: 'Ce poti vizita',
    'Tarif intreg': 'Tarif intreg',
    'Tarif elev / student': 'Tarif elev / student',
    Adult: 'Adult',
    Elev: 'Elev',
    Student: 'Student',
    Pensionar: 'Pensionar',
    Delfinariu: 'Delfinariu',
    Planetariu: 'Planetariu',
    Microrezervatie: 'Microrezervatie',
    Parcare: 'Parcare',
    go_to_schedule: 'Vezi programul de vizitare',
    faqs: 'Intrebari frecvente',
    easter_schedule: 'Program de Paste',
    friday: 'Vineri',
    saturday: 'Sambata',
    sunday: 'Duminica',
    monday: 'Luni',
    tuesday: 'Marti',
    tickets_desk_close: 'Casa de bilete se închide la ora 13:00',
    closed: 'Inchis',
    last_enter: 'ultima intrare',
    last_enter_floor: 'ultima intrare pentru turul de parter',
    last_enter_optional: 'Ultima intrare pentru turul opțional I se face la ora 12:30',
    school_children: 'Elevii beneficiază de intrare gratuită pe perioada vacanțelor școlare.',
    under7: 'Copiii în vârstă de până la 7 ani beneficiază de intrare gratuită.',
    invoice: 'Factura',
    invoice_info: 'Dacă dorești factură fiscală pentru comanda ta pe delfinariu.bilet.ro, te rugăm să completezi cu atenție formularul de mai jos.',
    transaction_id: 'Numar comanda',
    email_address: 'Adresă de e-mail',
    visit_date: 'Data efectuării vizitei',
    full_name: 'Nume și prenume',
    company_name: 'Denumire firmă',
    cui: 'CUI',
    reg_com: 'Registrul Comerțului',
    address: 'Adresă sediu social/Adresă',
    bank: 'Banca',
    iban: 'Cont (IBAN)',
    invoice_type: 'Tipul facturii',
    country: 'Țara',
    company_representative: 'Reprezentantul companiei',
    company: 'Persoana juridică',
    individual: 'Persoană fizică',
    barcode: 'Cod de bare al unui bilet',
    barcode_invoice_info: 'pentru a demonstra posesia biletului',
    email_address_invoice_info: 'adresa de e-mail la care dorești să primești factura',
    invoice_aggree: 'Sunt de acord ca, în conformitate cu prevederile Regulamentului UE nr. 679/2016 și cu celelalte acte normative aflate în vigoare în materia protecției datelor cu caracter personal, datele cu caracter personal furnizate de către mine (nume şi prenume, adresă sau reședință, adresă e-mail, informații bancare) să fie prelucrate de către Delfinariu Constanta în scopul emiterii facturii fiscale.',
    invoice_send: 'Trimite',
    invoice_request_ok: 'Cererea de factura a fost trimisa cu succes.',
    invoice_generated_ok: 'Factura a fost generata cu succes si trimisa pe adresa de email completata.',
    invoice_request_error: 'Cererea de factura nu a putut fi trimisa cu succes. Verificati numarul de comanda si codul de bare ca sunt corecte.',
    invoice_already_printed: 'Factura a fost deja generata.',
    invalid_cui: 'CUI-ul introdus nu este valid.',
    refund_policy: 'Politica de retur',
    refund_detail_2: 'Biletele online cumpărate de pe delfinariu.bilet.ro inainte de 23.05.2025 au o valabilitate de 14 zile. Dacă termenul de 14 zile a fost depășit fără a utiliza biletul, valoarea biletului nu se returnează.',
    refund_detail_1: 'Biletele pentru vizitarea Delfinariu Constanta se vând cu rezervare orară, în limita locurilor disponibile și nu se returnează.',
    refund_title: 'Cerere de returnare a contravalorii biletului',
    ticket_identificator: 'Seria biletului/ID comandă/Data achiziției',
    refund_info: 'Banii vor fi returnați în contul din care ați făcut plata. Se returnează contravaloarea biletelor, nu și valoarea taxei de procesare a tranzacției.',
    refund_bank_details: 'Detaliile contului bancar în care doriți să vă returnăm valoarea biletului (numele, prenumele, numele băncii, cod IBAN)',
    refund_reason: 'Motivul pentru care doriți returnarea banilor',
    refund_request_ok: 'Cererea de retur a fost trimisa cu succes.',
    refund_request_error: 'Cererea de retur nu a putut fi trimisa cu succes. Verificati numarul de comanda ca este corect introdus.',
    refund_aggree: 'Sunt de acord ca, în conformitate cu prevederile Regulamentului UE nr. 679/2016 și cu celelalte acte normative aflate în vigoare în materia protecției datelor cu caracter personal, datele cu caracter personal furnizate de către mine (nume şi prenume, adresă sau reședință, adresă e-mail, informații bancare) să fie prelucrate de către Delfinariu Constanta în scopul procesarii cererii de rambursare.', 
    contact_technical: 'Detalii tehnice achizitie bilete',
    contact_museum: 'Detalii vizitare',
    confirm_hour_add_title: 'Atentie!',
    confirm_hour_add_msg: 'Castelul s-a inchis pentru ziua de astazi!',
    Cancel: 'Renunta',
    add_to_cart: 'Adauga in cos',
    mandatory_field: 'Câmpul este obligatoriu.',
    wrong_email: 'Email invalid.',
    password_mismatch: 'Parolele nu se potrivesc.',
    terms_mandatory: 'Va rugam sa acceptati termenii si conditiile.',
    phone_invalid: 'Numărul de telefon nu este valid.',
    hour: 'Ora',
    access_interval: 'Interval intrare',
    select_date: 'Selecteaza ziua',
    select_access_interval: 'Selecteaza intervalul de intrare',
    info_fewer_tickets: 'Au fost selectate mai putine locuri decat dorite',
    could_not_select_all: 'Nu s-au putut selecta toate biletele.',
    info_no_tickets: 'Nu mai sunt bilete disponibile',
    could_not_select: 'Eroare selectie bilete',
    free_seat_info: 'Tranzactia trebuie sa contina cel putin un bilet cu valoare. Pentru achizitionarea a mai mult de 3 bilete gratuite te rugam sa te prezinti la casieria situata in incinta Delfinariu Constanta.',
    non_refundable_condition: 'Am luat la cunostinta ca biletul nu poate fi folosit in afara zilei si a intervalului orar pentru care a fost achizitionat iar contravaloarea lui nu se returneaza indiferent de motivul invocat.',
    today: 'Astăzi',
    tomorrow: 'Mâine',
    empty_cart: 'Cosul este gol',
    group_tickets: 'Grupează biletele',
    quantity: 'Numar bilete',
    ticket_type: 'Tip bilet',
    discount: 'Reducere',
    price: 'Preț',
    group_tickets_info: "Grupeaza pentru a scana acelasi cod QR pentru biletele identice (aceeasi data, ora, pret si reducere).",
    parking_details: 'Detalii parcare',
    parking_details_info: 'Accesul masinilor in interiorul parcarii se face pe baza numarului de inmatriculare. Va rugam completati cu atentie numarul (numerele) de inmatriculare:',
    licence_plate: 'Numar de inmatriculare',
    licence_plate_required: 'Te rugam sa completezi numarul de inmatriculare.',
    licence_plate_min_length: 'Numarul de inmatriculare trebuie sa contina cel putin 3 caractere.'
}


